/**
 * Return:
 * a < b : > 0
 * a === b : 0
 * a > b : < 0
 *
 * @param a
 * @param b
 */
function compareCards(a: string, b: string): number {
  const aVal = parseInt(a.slice(1).replace('J', '11').replace('Q', '12').replace('K', '13').replace('A', '14'));
  const bVal = parseInt(b.slice(1).replace('J', '11').replace('Q', '12').replace('K', '13').replace('A', '14'));
  return bVal - aVal;
}

export default compareCards;
